import { SetFilterModel } from "@ag-grid-enterprise/set-filter";
import { ColumnState } from "ag-grid-community";
import { Subscription } from "rxjs";


/**
 * For objects that only returns id and name
 */
export class IdName {
  id!: string;
  name!: string;
}

export class SubscriptionObject {
  [key: string]: Subscription;
}

export class IdNameMaybe {
  id: string | null = null;
  name: string | null = null;
}

export class IdNameNumber extends IdName {
  number!: string;
}

export class IdNameColors extends IdNameMaybe {
  textColor: string | null;
  backgroundColor: string | null;
}

export class IdNamePriority extends IdName {
  priority: number = 0;
}

export class KeyValue {
  key!: string;
  value!: string;
}

export class GridStakeholderStateFilter {
  columnState: ColumnState[] | null = [];
  filterModel: SetFilterModel[] | null = [];
}

export class CompanyInformation {
  address?: string;
  companyLanguage!: string;
  companyNumber!: number;
  companyType!: string;
  email?: string;
  googleAnalyticsId: string | null = null;
  id!: string;
  logo?: string;
  name!: string;
  originId!: string;
  phone?: string;
  vat?: string;
  website?: string;
}

export type CompanyLanguage = 'da-DK' | 'de-DE' | 'en-US' | 'es-ES' | 'fo-FO' | 'nn-NO' | 'sv-SE' ;

export class Section {
  companyId!: string;
  companyKeyValuePairSettingsId!: string;
  name!: string;
  value!: string;
  section!: string;
  sort?: number;
}

export class PriceGroup {
  costPrice!: number;
  createdAt!: string;
  description!: string;
  lastModified!: string;
  listPrice!: string;
  name!: string;
  priceGroupId!: string;
  showInService!: string;
}

export class CompanyProfit {
  id!: string;
  startNumber!: number;
  endNumber!: number;
  priceStart!: number;
  priceEnd!: number;
  profit!: number;
  companyId!: string;
  createdAt!: string;
}

export class AddProfit {
  startNumber!: number;
  endNumber!: number;
  priceStart!: number;
  priceEnd!: number;
  profit!: number;
}

export class Files {
  files!: Folder[];
}

export class Folder {
  folderId: string | null = null;
  parentFolderId: string | null = null;;
  folderName: string = '';
  files: FileDetail[] = [];
}

export class FileDetail {
  fileId!: string;
  originalName!: string;
  fileTypeId!: string;
  extension!: string;
  path!: string;
  fileAccess!: string;
}

export class FolderContent {
  id!: string;
  name!: string;
  files!: FileDetail[];
}